import React, { Component } from 'react';

import './index.css';
import request from '../client/client';

class FormItems extends Component {

  state = {
    criarItemError: null,
    criarItemSuccess: null
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  clear = () => {
    localStorage.clear();
    this.props.history.replace('/');
  }

  criarItem = async (e) => {
    e.preventDefault();

    const menuFrom = await localStorage.getItem('storeID');

    if(this.state.criarItemError !== null || this.state.criarItemSuccess !== null){
      this.setState({
        criarItemError: null,
        criarItemSuccess: null
      })
    }

    try {
      await request.post('/items', {
        "name": this.state.name,
        "price": this.state.price,
        "menuFrom": menuFrom,
      })

      this.setState({
        criarItemSuccess: "Item adicionado com sucesso ;)"
      })
    } catch (err) {
      console.log(err);
      this.setState({
        /* Adicionar tratamento de erro mais específico */
        criarItemError: "Item não pode ser adicionado"
      })
    };
  }

  render() {
    return (
      <div className="text-center">
        <form onSubmit={this.criarItem}>
          <input
            className="form-item"
            placeholder="Nome"
            name="name"
            type="text"
            onChange={this.handleChange}
          />
          <input
            className="form-item"
            placeholder="Valor"
            name="price"
            type="text"
            onChange={this.handleChange}
          />
          {
            !!this.state.criarItemError &&
            <div className="error-message">
              {this.state.criarItemError}
            </div>
          }
          {
            !!this.state.criarItemSuccess &&
            <div className="error-message">
              {this.state.criarItemSuccess}
            </div>
          }
          <input
            className="form-submit"
            value="Enviar"
            type="submit"
          />
          <a className="logout" onClick={this.clear} href="#">Encerrar inserções e Sair do cliente</a>
        </form>
      </div>
    )
  }
}

export default FormItems;



// WEBPACK FOOTER //
// ./src/components/form-items/index.js